import { CustomDropDownMenuIcon } from 'assests/GmsIcons';
import React, { FC, useContext, useEffect, useState } from 'react'
import { ProductsContext } from '../ProductsContext';
import { useHistory } from 'react-router-dom';
import { PRODUCT_DELTA_LIST } from '../ProductConstants';
import { TFilters } from 'types/hooks/useTable';

interface ProductCategoryDropDownProps {
    fetchData: (catId: any) => void,
    setFilters: (filters: TFilters) => void
}

const ProductCategoryDropDown: FC<ProductCategoryDropDownProps> = ({ fetchData, setFilters }) => {
    const prodContext = useContext<any>(ProductsContext);
    const [selectWidth, setSelectWidth] = useState<string>('auto');
    const history = useHistory();

    useEffect(() => {
        const optionWidth = calculateTextWidth(prodContext.selected_Category.name);
        setSelectWidth(`${optionWidth + 85}px`);
    }, [prodContext.selected_Category.name]);

    const handleSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setFilters({ limit: prodContext.pageSize ?? undefined })
        const selectedCategoryId = event.target.value;
        prodContext.resetAttributeData()
        history.push(`${PRODUCT_DELTA_LIST}/${selectedCategoryId}`);
    };

    const calculateTextWidth = (text: string) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) {
            console.error("Could not get canvas context");
            return 0;
        }
        context.font = getComputedStyle(document.body).font;
        const width = context.measureText(text).width;

        return width;
    };


    return (
        <div className='tw-flex tw-items-center'>
            <select style={{ width: selectWidth }} className={`tw-bg-transparent tw-border-none tw-outline-none tw-appearance-none tw-text-[20px] tw-text-[#091E42] tw-pr-2 tw-font-semibold`} value={prodContext.selected_Category.id} onChange={handleSelect}>
                <option value={undefined} disabled={prodContext.selected_Category.id !== undefined}>
                    Loading Category ...
                </option>
                {prodContext.categoryData.map((item: any, index: any) => {
                    return (
                        <optgroup className="tw-text-xs" label={item.name} key={item.name}>
                            {item.category.map((category: any) => (
                                <option value={category.id} key={category.id}>
                                    {category.name}
                                </option>
                            ))}

                        </optgroup>
                    );
                })}
            </select>
            <CustomDropDownMenuIcon />
        </div>
    )
}

export default ProductCategoryDropDown